// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"Il","zenCrossSiteLabel":"Jl","vrsnlCrossSiteLabel":"Kl"};